// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as UseApi$Showside from "../hook/UseApi.bs.js";
import * as UseEnv$Showside from "../hook/UseEnv.bs.js";
import * as Category$Showside from "../types/Category.bs.js";
import * as SmartImg$Showside from "../utils/SmartImg.bs.js";
import * as URLUtils$Showside from "../utils/URLUtils.bs.js";
import * as QuickView$Showside from "../components/QuickView.bs.js";
import * as QuickViewT$Showside from "../types/QuickViewT.bs.js";
import * as BaseWithTheme$Showside from "../context/BaseWithTheme.bs.js";
import * as Configuration$Showside from "../types/Configuration.bs.js";
import * as ErrorBoundary$Showside from "../utils/ErrorBoundary.bs.js";
import * as QuickViewMedia$Showside from "../components/QuickViewMedia.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as UseContainerSize$Showside from "../hook/UseContainerSize.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as PausePageScrolling$Showside from "../components/PausePageScrolling.bs.js";
import * as RelatedMediaContent$Showside from "../components/RelatedMediaContent.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as PictureInPictureContext$Showside from "../utils/PictureInPictureContext.bs.js";
function useProductsLoader(productIds) {
  var match = ConfigurationProvider$Showside.use(undefined);
  var match$1 = match.config;
  var hideOutOfStock = match$1.settings.hideOutOfStock;
  var match$2 = EntrypointContext$Showside.use(undefined);
  var market = match$2.market;
  var smartnavApiHost = match$2.smartnavApiHost;
  var cachedProducts = UseApi$Showside.useCacheOnlyProducts(smartnavApiHost, market, hideOutOfStock, productIds);
  var pendingProductIds = React.useMemo(function () {
    return Belt_Array.keep(productIds, function (id) {
      return Belt_Array.every(cachedProducts, function (product) {
        return product.id !== id;
      });
    });
  }, [productIds]);
  var match$3 = UseApi$Showside.useProductsById(match$1.transitiveStoreId, pendingProductIds, hideOutOfStock, true, "", smartnavApiHost, market, undefined);
  var products = match$3.products;
  return React.useMemo(function () {
    return Belt_Array.concat(cachedProducts, Belt_Option.getWithDefault(products, []));
  }, [products, cachedProducts]);
}
function useMedia(parentCategoryInConfig, categoriesInConfigOpt, pagesOpt, carousel) {
  var categoriesInConfig = categoriesInConfigOpt !== undefined ? categoriesInConfigOpt : [];
  var pages = pagesOpt !== undefined ? pagesOpt : [];
  var match = UseContainerSize$Showside.use(true);
  var containerHeight = match[1];
  var containerWidth = match[0];
  var mediaInConfig = React.useMemo(function () {
    return Belt_Array.mapWithIndex(categoriesInConfig, function (order, category) {
      return QuickViewT$Showside.makeMediaFromCategory(containerWidth, containerHeight, order, parentCategoryInConfig, category);
    });
  }, [categoriesInConfig]);
  return React.useMemo(function () {
    var existingMedia = {
      contents: mediaInConfig
    };
    Belt_Array.forEach(pages, function (page) {
      var leftMedia = Belt_Array.keep(Belt_Array.slice(existingMedia.contents, 0, page.offset), function (media) {
        return media.kind !== "placeholder";
      });
      var lastLeftMedia = Belt_Array.get(leftMedia, leftMedia.length - 1 | 0);
      var rightMedia = Belt_Array.keep(Belt_Array.sliceToEnd(existingMedia.contents, page.offset), function (media) {
        return media.kind !== "placeholder";
      });
      var firstRightMedia = Belt_Array.get(rightMedia, 0);
      var needLeftPlaceholder = page.previous !== undefined && Belt_Option.mapWithDefault(lastLeftMedia, true, function (m) {
        return m.order !== (page.offset - 1 | 0);
      });
      var needRightPlaceholder = page.next !== undefined && Belt_Option.mapWithDefault(firstRightMedia, false, function (m) {
        return m.order !== (((page.offset - 1 | 0) + page.categories.length | 0) - 1 | 0);
      });
      var leftMedia$1 = Belt_Array.concat(leftMedia, needLeftPlaceholder ? [QuickViewT$Showside.makePlaceholderMedia(page.offset)] : []);
      var middleMedia = Belt_Array.mapWithIndex(page.categories, function (i, cat) {
        return QuickViewT$Showside.makeMediaFromCategory(containerWidth, containerHeight, i + page.offset | 0, parentCategoryInConfig, cat);
      });
      var rightMedia$1 = Belt_Array.concat(needRightPlaceholder ? [QuickViewT$Showside.makePlaceholderMedia(page.offset + page.categories.length | 0)] : [], rightMedia);
      existingMedia.contents = Belt_Array.mapWithIndex(QuickViewT$Showside.dedupById(Belt_Array.concat(Belt_Array.concat(leftMedia$1, middleMedia), rightMedia$1)), function (i, m) {
        return {
          order: i,
          id: m.id,
          kind: m.kind,
          title: m.title,
          showTitle: m.showTitle,
          description: m.description,
          link: m.link,
          overlayKind: m.overlayKind,
          originalWidth: m.originalWidth,
          originalHeight: m.originalHeight,
          src: m.src,
          fallbackImageUrl: m.fallbackImageUrl,
          pins: m.pins
        };
      });
    });
    return existingMedia.contents;
  }, [pages]);
}
function useQuickViewConfig(initialLocation, param) {
  var match = RouterProvider$Showside.useRouter(undefined);
  var route = match.route;
  var match$1 = ConfigurationProvider$Showside.use(undefined);
  var match$2 = match$1.config;
  var settings = match$2.settings;
  var topLevelCategories = match$2.categories;
  var match$3 = ViewportContext$Showside.use(undefined);
  var match$4 = UseEnv$Showside.use(undefined);
  var smartnavApiHost = match$4.smartnavApiHost;
  var initialMediaId = React.useMemo(function () {
    if (initialLocation !== undefined) {
      var mediaId = initialLocation.quickView.mediaId;
      if (mediaId !== undefined) {
        return mediaId;
      }
    }
    if (typeof route === "number" || route.TAG !== /* QuickView */3) {
      return;
    } else {
      return route._0.mediaId;
    }
  }, []);
  var match$5;
  var exit = 0;
  if (initialLocation !== undefined) {
    var match$6 = initialLocation.quickView;
    var mediaId = match$6.mediaId;
    if (mediaId !== undefined) {
      match$5 = [mediaId, match$6.mediaParentId, match$6.relatedMediaProductIds, match$6.relatedMediaCategoryId];
    } else {
      exit = 1;
    }
  } else {
    exit = 1;
  }
  if (exit === 1) {
    if (typeof route === "number" || route.TAG !== /* QuickView */3) {
      match$5 = ["", undefined, undefined, undefined];
    } else {
      var match$7 = route._0;
      match$5 = [match$7.mediaId, match$7.mediaParentId, match$7.relatedMediaProductIds, match$7.relatedMediaCategoryId];
    }
  }
  var qvRelatedCategoryId = match$5[3];
  var qvRelatedProductIds = match$5[2];
  var qvMediaParentId = match$5[1];
  var qvMediaId = match$5[0];
  var tmp;
  tmp = qvMediaParentId === "related-media" ? qvRelatedCategoryId !== undefined ? {
    TAG: /* ByCategoryId */1,
    _0: qvRelatedCategoryId
  } : qvRelatedProductIds !== undefined ? {
    TAG: /* ByProductIds */0,
    _0: qvRelatedProductIds
  } : /* NoSource */0 : /* NoSource */0;
  var relatedMedia = RelatedMediaContent$Showside.useRelatedMedia(undefined, undefined, /* QuickView */2, undefined, tmp);
  var parentCategoryInConfig = React.useMemo(function () {
    return Belt_Option.orElse(Belt_Option.orElse(Belt_Option.flatMap(qvMediaParentId, function (param) {
      return Category$Showside.getCategoryById(topLevelCategories, param);
    }), relatedMedia), Category$Showside.getCategoryParentById(topLevelCategories, qvMediaId));
  }, [qvMediaId, qvMediaParentId, relatedMedia]);
  var categoriesInConfig = React.useMemo(function () {
    return Belt_Option.map(parentCategoryInConfig, Category$Showside.getChildren);
  }, [parentCategoryInConfig]);
  var carousel = settings.quickviewCarousel;
  var autoPlay = settings.quickviewAutoplay;
  var carousel$1 = carousel && !match$3.isMobile;
  var isStories = Belt_Option.mapWithDefault(parentCategoryInConfig, false, Category$Showside.isQuickViewStoriesEnabled);
  var match$8 = Belt_Option.map(parentCategoryInConfig, function (parent) {
    return parent.categoryType;
  });
  var initialPageUrl;
  if (match$8 !== undefined && typeof match$8 !== "number") {
    switch (match$8.TAG | 0) {
      case /* QuickView */2:
        initialPageUrl = match$8._0.loadMoreChildren;
        break;
      case /* Standard */1:
      case /* ConfigEmbed */4:
        initialPageUrl = match$8._0.loadMoreChildren;
        break;
      default:
        initialPageUrl = undefined;
    }
  } else {
    initialPageUrl = undefined;
  }
  var match$9 = React.useState(function () {
    return Belt_Option.flatMap(categoriesInConfig, function (__x) {
      return Category$Showside.getCategoryById(__x, qvMediaId);
    });
  });
  var initialMediaInConfig = match$9[0];
  var initialPageUrl$1 = React.useMemo(function () {
    if (initialPageUrl !== undefined && initialMediaId !== undefined && initialMediaInConfig === undefined) {
      return URLUtils$Showside.changeParam(URLUtils$Showside.changeParam(URLUtils$Showside.addHostnameMaybe(initialPageUrl, smartnavApiHost), "offset", undefined), "offset_by_node_id", initialMediaId);
    } else {
      return initialPageUrl;
    }
  }, [initialPageUrl, initialMediaId, initialMediaInConfig]);
  var match$10 = UseApi$Showside.usePaginateCategories(true, smartnavApiHost, Configuration$Showside.nodeLimit, initialPageUrl$1, undefined);
  var direction = match$10.direction;
  var setDirection = match$10.setDirection;
  var match$11 = match$10.swr;
  var setSize = match$11.setSize;
  var size = match$11.size;
  var pages = Belt_Option.getWithDefault(match$11.data, []);
  var numLoadedPages = pages.length;
  var media = useMedia(parentCategoryInConfig, categoriesInConfig, pages, carousel$1);
  var previousPage = Belt_Option.flatMap(Belt_Array.get(pages, 0), function (data) {
    return data.previous;
  });
  var nextPage = Belt_Option.orElse(Belt_Option.flatMap(Belt_Array.get(pages, pages.length - 1 | 0), function (data) {
    return data.next;
  }), initialPageUrl$1);
  React.useEffect(function () {
    var currentMediaIndex = Belt_Array.getIndexBy(media, function (media) {
      return media.id === qvMediaId;
    });
    if (currentMediaIndex !== undefined) {
      var closestLeftPlaceholderIndex = Belt_Array.map(media.slice(0, currentMediaIndex), function (m) {
        return m.kind;
      }).lastIndexOf("placeholder");
      var closestRightPlaceholderIndex = Belt_Array.map(media, function (m) {
        return m.kind;
      }).indexOf("placeholder", currentMediaIndex);
      var numOfNeighboringMedia = Math.abs((closestRightPlaceholderIndex > 0 ? closestRightPlaceholderIndex : 0) - (closestLeftPlaceholderIndex > 0 ? closestLeftPlaceholderIndex : 0) | 0);
      var currentMediaIndexRelativeToLeftPlaceholder = currentMediaIndex - closestLeftPlaceholderIndex | 0;
      var tooCloseToLeft = currentMediaIndexRelativeToLeftPlaceholder <= (numOfNeighboringMedia / 2 | 0);
      var tooCloseToRight = currentMediaIndexRelativeToLeftPlaceholder > (numOfNeighboringMedia / 2 | 0);
      var exit = 0;
      if (tooCloseToLeft && direction >= 0) {
        Curry._1(setDirection, -1);
        Curry._1(setSize, size + 1 | 0);
      } else {
        exit = 1;
      }
      if (exit === 1) {
        if (tooCloseToRight && direction <= 0 && numLoadedPages >= size) {
          Curry._1(setDirection, 1);
          Curry._1(setSize, size + 1 | 0);
        } else {
          Curry._1(setDirection, 0);
        }
      }
    }
  }, [qvMediaId]);
  var productIds = React.useMemo(function () {
    return Belt_Array.concatMany(Belt_Array.map(media, function (media) {
      return Belt_Array.map(media.pins, function (pin) {
        return pin.productId;
      });
    }));
  }, [media]);
  var loadedProducts = useProductsLoader(productIds);
  return React.useMemo(function () {
    return {
      isStories: isStories,
      media: media,
      products: loadedProducts,
      carousel: carousel$1,
      autoPlay: autoPlay
    };
  }, [isStories, media, nextPage, previousPage, loadedProducts, carousel$1, autoPlay]);
}
function QuickViewOverlay(Props) {
  PausePageScrolling$Showside.usePausePageScrolling(undefined);
  var match = RouterProvider$Showside.useRouter(undefined);
  var route = match.route;
  ConfigurationProvider$Showside.use(undefined);
  var qvMediaId;
  qvMediaId = typeof route === "number" || route.TAG !== /* QuickView */3 ? undefined : route._0.mediaId;
  var config = useQuickViewConfig(undefined, undefined);
  var getSourceEl = React.useCallback(function (param) {}, []);
  var match$1 = PictureInPictureContext$Showside.use(undefined);
  var setPictureInPicture = match$1.setMediaId;
  React.useEffect(function () {
    if (setPictureInPicture !== undefined) {
      Curry._5(setPictureInPicture, undefined, undefined, undefined, undefined, undefined);
    }
  }, [qvMediaId]);
  var renderMediaBackdrop = React.useCallback(function (media) {
    return Belt_Option.mapWithDefault(media.fallbackImageUrl, null, function (poster) {
      return React.createElement(SmartImg$Showside.ColorOverlay.make, {
        src: poster
      });
    });
  }, []);
  return React.createElement(BaseWithTheme$Showside.make, {
    initiator: "quickview",
    portal: true,
    children: React.createElement(ErrorBoundary$Showside.make, {
      componentName: "QuickView",
      redirect: match.back,
      children: React.createElement(QuickView$Showside.make, {
        config: config,
        getSourceEl: getSourceEl,
        renderMedia: QuickViewMedia$Showside.renderMedia,
        renderMediaBackdrop: renderMediaBackdrop
      })
    })
  });
}
QuickViewOverlay.displayName = "QuickViewOverlay";
var make = QuickViewOverlay;
var $$default = QuickViewOverlay;
export { useProductsLoader, useMedia, useQuickViewConfig, make, $$default, $$default as default };
/* react Not a pure module */